import { Document } from "@daytrip/legacy-models";
import { isUndefinedOrNull } from "@daytrip/utils";
import autobind from "autobind-decorator";
import { action, observable } from "mobx";

import { ModelOperator } from "./ModelOperator";

@autobind
export class DocumentOperator extends ModelOperator<Document, {}, null, null, null> {
    @observable
    public documentDeclinationReason?: string;

    @action
    public onChangeDeclinationReason(value: string) {
        this.documentDeclinationReason = value;
    }

    @action
    public async approveDocument() {
        try {
            this.model = await this.rpcClient.driver.approveDocument(this.m._id);
        } catch (e: any) {
            alert("Oh, something got wrong. :(");
        }
    }

    @action
    public async declineDocument() {
        if (isUndefinedOrNull(this.documentDeclinationReason) || this.documentDeclinationReason == "") {
            alert("Please write some declination reason.");
            return;
        }

        try {
            this.model = await this.rpcClient.driver.declineDocument(this.m._id, this.documentDeclinationReason);
            this.documentDeclinationReason = undefined;
        } catch (e: any) {
            alert("Oh, something got wrong. :(");
        }
    }
}
